var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { I18NLink } from "../../I18N";

import { Icon } from "../../Layout";
import * as actions from "../../Relationships/actions/actions";





const mapStateToProps = ({ entityView }) => ({
  uiState: entityView.uiState
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      selectConnection: actions.selectConnection
    },
    dispatch
  );
}

const connector = connect(mapStateToProps, mapDispatchToProps);



const RelationshipLink = ({ propValue: propVal, selectConnection }) => {
  if (propVal.relatedEntity) {
    return /*#__PURE__*/(
      _jsx("button", {
        type: "button",
        className: "link-button",
        onClick: () => selectConnection(propVal.relatedEntity) },
      propVal.url,

      propVal.icon && /*#__PURE__*/_jsx(Icon, { className: "item-icon", data: propVal.icon }),
      propVal.value
      ));

  }
  return /*#__PURE__*/(
    _jsx(I18NLink, { to: propVal.url }, propVal.url,
    propVal.icon && /*#__PURE__*/_jsx(Icon, { className: "item-icon", data: propVal.icon }),
    propVal.value
    ));

};

const container = connector(RelationshipLink);
export { container as RelationshipLink };